// extracted by mini-css-extract-plugin
export default {"rating":"Rating_rating__0L5ah","up":"Rating_up__LdA5z","down":"Rating_down__1xTJ-"};